import React from 'react';

const NavbarPublic = ({ logoCCBJI, logoFVJ, backToLogin }) => {
    return (
        <nav className="navbar navbar-expand-lg navbar-light justify-content-start bg-white p-0">
            <ul className="navbar-nav ms-auto">
                <li
                    className="nav-item d-flex justify-content-around"
                    onClick={backToLogin}
                    style={{ height: '71px' }}
                >
                    <img className="m-1" src={logoCCBJI} alt="Logo 1" style={{ height: '90%' }} />
                    <img className="m-1" src={logoFVJ} alt="Logo 2" style={{ height: '90%' }} />
                </li>
            </ul>
        </nav>
    );
};

export default NavbarPublic;